import json from './sprite.js';

export default {
    handle: 'ENG_SPS8-AfterSchool',
    label: 'en_SPS8-AfterSchool_225001715',
    json,
};
